import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.email || !form.password) {
      setError('Ingresa tu correo y contraseña.');
      return;
    }
    // Autenticación simulada: este proyecto es solo frontend de demostración.
    setError('');
    alert('Inicio de sesión simulado. Conecta este formulario a tu backend de autenticación.');
  };

  return (
    <section className="section page-section auth-page">
      <div className="auth-card">
        <h1>Iniciar sesión</h1>
        <p>Accede a tu cuenta para guardar favoritos y solicitar cotizaciones más rápido.</p>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <label>
            Correo electrónico
            <input
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </label>
          <label>
            Contraseña
            <input
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
            />
          </label>
          <button type="submit" className="btn btn-primary btn-block">Entrar</button>
        </form>
        <p className="auth-switch">
          ¿No tienes cuenta? <Link to="/registro">Regístrate aquí</Link>
        </p>
      </div>
    </section>
  );
}
